import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { kidState } from "./types";
import { RootState } from "../types";

const initialState: kidState = {};

export const kid: Module<kidState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
